import React from 'react';
import ReactDOM from 'react-dom';
import charWatchTrack from '../shared/CharWatchTrack';

class NumTrack extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charWatchTrack(NumTrack, 'num', 'track');


// WEBPACK FOOTER //
// ./src/components/sections/num/NumTrack.js